module.exports = new __parcel__URL__("linkedin-icon.01cc0daf.svg").toString();